let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e0f4q")).then(() => parcelRequire('lHABM'));